import { makeStyles } from '@material-ui/core/styles';
import { drawerWidth } from '~/config/layout';

export default makeStyles(theme =>
  ({
  button:{
    marginBottom:30,
    marginRight:30,
  },
  checkBox:{
    marginBottom:26,
    marginRight:20,
  },
  footerDrawerClosed: {
    backgroundColor: 'white',
    position: 'fixed',
    width: `calc(100% - ${theme.spacing(9)}px)`,
    height: '66px',
    bottom: 0,
    right:0,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '6px',
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  footerDrawerOpen:{
    backgroundColor: 'white',
    position: 'fixed',
    width: `calc(100% - ${drawerWidth}px)`,
    height: '66px',
    bottom: 0,
    right:0,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    borderRadius: '6px',
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

